import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useNavigate } from 'react-router-dom'

type Props = {
  text: string
}

export function ModalConfirm({ text }: Props) {
  const navigate = useNavigate()
  const t = useAppStore.use.t()
  const openModal = useAppStore.use.openModal()
  const closeModal = useAppStore.use.closeModal()

  function handleClickEdit() {
    closeModal()
    navigate('/planner')
  }

  function handleClickNew() {
    openModal()
    navigate('/planner/create/new')
  }

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Content className='dialog white-background absolute left-1/2 top-1/2 z-50 h-min w-72 -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-C/Color2 bg-C/Color1 px-3 pt-3 text-left text-xs shadow-xl '>
          <div className='flex flex-col items-center justify-center gap-y-1.5'>
            <p className='font-normal'>{'¿Quieres borrar las paredes existentes?'}</p>
            <div className='button container mb-2 flex w-full justify-center gap-x-3'>
              <button
                onClick={handleClickNew}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color7 bg-C/Color3 px-3 py-0.5 text-xs font-normal text-C/Color1'
              >
                {'Sí'}
              </button>
              <button
                onClick={handleClickEdit}
                className='flex cursor-pointer items-center rounded-xl border border-C/Color3 bg-C/Color7 px-3 py-0.5 text-xs font-normal text-C/Color3 '
              >
                {'No'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
